import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center" data-testid="not-found-page">
      <div className="font-display font-extrabold text-7xl text-emerald-700">404</div>
      <h1 className="mt-4 font-display font-bold text-2xl text-slate-900">Page not found</h1>
      <p className="mt-2 text-slate-600">The page you’re looking for doesn’t exist.</p>
      <Button asChild className="mt-6 bg-emerald-700 hover:bg-emerald-800 text-white">
        <Link to="/">Back to Home</Link>
      </Button>
    </div>
  );
}
